export const THREAD_ENTITY_TYPE: string = 'MMP_ORDER'
export const SUBJECT_TYPE_INCIDENT_CLOSE: string = 'INCIDENT_CLOSE'
export const SUBJECT_TYPE_INCIDENT_OPEN: string = 'INCIDENT_OPEN'
export const SUBJECT_TYPE_OFFER_MESSAGING: string = 'OFFER_MESSAGING'
export const SUBJECT_TYPE_ORDER_MESSAGING: string = 'ORDER_MESSAGING'
export const SUBJECT_TYPE_CANCELATION: string = 'CANCELATION'
export const PARTICIPANT_TYPE_OPERATOR: string = 'OPERATOR'
export const PARTICIPANT_TYPE_CUSTOMER: string = 'CUSTOMER'
export const PARTICIPANT_TYPE_SHOP: string = 'SHOP'
export const PARTICIPANT_TYPE_ID: string = '2058' // This should be removed and we should not hardcoded the SHOP ID
export const REASON_CODE = 'REASON_CODE'
export const ALLOWED_SUBJECT_CODES: string[] = [
  '21',
  '24',
  '22',
  '25',
  '20',
  '26'
]

export const INCIDENT_SUBJECT_CODES: string[] = ['1', '3', '4', '5']
export const CONTACT_SELLER_INITIAL_DEFAULT_MESSAGE_ID: string =
  'account.messageReason.defaultMessage.shippingQuestion'
export const OPEN_INCIDENT_INITIAL_DEFAULT_MESSAGE_ID: string =
  'account.messageReason.defaultMessage.articleNotShipped'

export const VISIBLE_THREADS_COUNT: number = 5

export const ALLOWED_FILE_TYPES: string[] = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png'
]
export const BYTE_TO_MEGABYTES_DENOMINATOR = 1.049e6

export const MAX_MESSAGE_LENGTH: number = 50000
export const MIN_MESSAGE_LENGTH: number = 3
export const MAX_FILE_SIZE_MB: number = 10
export const MAX_SIZE_ONE_FILE: number = 3

export const REQUEST_INVOICE_SUBJECT_CODE: string = '24' // The Mirakl code for invoice request subject message
